var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('page-header'),_c('div',{staticClass:"page-container"},[_c('router-view')],1),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }